<template>
    <div class="container">
      <!-- <span class="title">欢迎使用百草健康</span> -->
      <!-- <div class="about-content" v-html="about">{{ about }}</div> -->
      <div class="about-content">
        <p class="about-footer">天・地・人三元合参，循古创新，以体系之力，守护全民长久健康！</p>
        <p><strong>核心价值：</strong>守正、创新、融合、惠民 坚守中医本源，以数字科技活化古籍医理，贯通天时地利人和，让有据可依、有数可查的精准中医走进大众生活。</p>
        <p><strong>企业使命：</strong>科技赋能传统医学，体系化解行业难题，三元合参守护全民健康，古今融合传承中华医学真理。</p>
        <p><strong>企业愿景：</strong>打造全球领先的三元医学融合范式，让中华千年医学智慧惠及每一个家庭。</p>
      </div>
  </div>
</template>

<script>
import about from "../../js/about.js";
export default {
  data() {
    return {
      about: about,
    };
  },
};
</script>

<style scoped>
.container {
  width: 880px;
  min-height: 520px;
  height: auto;
  margin: auto auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title {
  margin-left: 20px;
  font-size: 32px;
  font-weight: bold;
  color: #333333;
}
.about-content {
  text-align: left;
  margin: 20px 0px;
  font-size: 20px;
}
.about-content > p {
  text-indent: 40px;
}
.about-content > p strong {
  
  font-weight: 700;
}
.about-footer {
  text-align: center;
  font-weight: 700;
  
  font-size: 22px;
  margin-top: 30px;
  text-indent: 0 !important;
}
</style>
